import React, { useContext } from "react";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import userContext from "../../context/user-context";
import { FiLogOut } from "react-icons/fi";
import clgocde_prici from "../../data/ccode_pno_map.json";

export const Navbar_loggedin = () => {
	const navigate = useNavigate();

	const { clgcode, setClgcode } = useContext(userContext);

	const collegeName =
		clgcode !== 0 &&
		clgocde_prici.filter((data) => data.ccode.toString() === clgcode)[0]?.cname;

	return (
		<header className="nav">
			<div className="nav-brand" onClick={() => navigate("/")}>
				<div className="nav-emblem">
					<img
						src="/image.png"
						alt="Government of Tamil Nadu"
					/>
				</div>
				<div className="nav-titles">
					<span className="nav-title">TNGASA</span>
					<span className="nav-sub">College Admissions</span>
				</div>
			</div>

			<div className="nav-right">
				{collegeName && (
					<div className="nav-college">
						<span className="nav-college-label">Signed in as</span>
						<span className="nav-college-name">{collegeName}</span>
					</div>
				)}
				<button
					className="logout-btn"
					onClick={() => {
						setClgcode(0);
						navigate("/");
					}}
				>
					<FiLogOut /> Logout
				</button>
			</div>
		</header>
	);
};
